module.exports = __webpack_public_path__ + "static/media/md-settings.4eabf90d.svg";